import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentOrganisationId } from 'hooks';

import { getBoardUsers } from '../requests';

type Params = {
  boardId: string;
};

const PER_PAGE = 50;

export const useGetBoardUsersInfinite = ({ boardId }: Params) => {
  const organisationId = useGetCurrentOrganisationId();

  return useQuery({
    queryKey: [API_QUERY_KEYS.boardUsers, organisationId, boardId, 'infinite'],
    queryFn: async () => {
      const {
        data,
        meta: { lastPage: pagesCount },
      } = await getBoardUsers({
        pathParams: { organisationId, boardId },
        queryParams: { page: 1, perPage: PER_PAGE },
      });

      if (pagesCount === 1) return data;

      const pageRequestsData = await Promise.all(
        Array.from({ length: pagesCount - 1 }, (_, index) => {
          const page = index + 2;
          return getBoardUsers({
            pathParams: { organisationId, boardId },
            queryParams: { page, perPage: PER_PAGE },
          });
        }),
      );

      return [...data, ...pageRequestsData.flatMap(page => page.data)];
    },
  });
};
